import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from "@angular/common";
import { SecoPilotingConfig } from "../../seco-piloting-config";

/**
 * A service to load SmartScripting API external javascript file. SmartScripting is a way to control Seco using html5
 * postMessage events.
 */
@Injectable()
export class ExternalCatalogLoader {
  private catalogLoaded = false;
  private _catalog: null = null;

  constructor(@Inject(DOCUMENT) private doc: any,
              @Inject('SMARTSCRIPT_WINDOW') private win: any,
              private config: SecoPilotingConfig
              ) {


    /**
     * This is a workaround (Part 1):
     * ExternalCatalog.js adds a postMessage event handler like the one below to the window. ExternalCatalog.js uses a
     * globally declared function 'listener' as event handler. This function does a JSON.parse(event.data) which throws
     * an exception when event.data is not a string. This is why we wrap the 'listener' function in a try/catch and
     * deregister the eventhandler from ExternalCatalog.js (see Part2)
     */
    win.addEventListener('message', (e) => {
      try {
        win['listener'](e);
      } catch (e) {
      }
    }, true);
  }

  /**
   * Loads external script and resolves when loaded, rejects otherwise. Browser caching makes sure actual http request
   * is made only once.
   */
  public loadCatalog(): Promise<any> {
    return this.config.externalCatalogUrl$
      .then((url) => {
        return new Promise((resolve, reject) => {
          const {doc} = this;
          const script = doc.createElement('script');
          script.src = url.href;
          script.onload = () => {
            /**
             * This is a workaround (Part 2):
             * Deregister the eventlistener that comes with ExternalCatalog.js so that only the one wrapped in a try/catch
             * is used (Part 1).
             */
            this.win.removeEventListener('message', this.win['listener']);
            this.catalogLoaded = true;
            this._catalog = this.win['catalog'];
            resolve(this._catalog);
          };
          script.onerror = reject;
          doc.head.appendChild(script);
        })
      });

  }
}
